import { createContext } from 'react';

import type { Employee, Task } from 'types/interfaces';
import type { EmployeeAssignmentRulesParams } from 'utils/taskEmployeeAssignmentRules';

export type DistributionRowContextValue = {
  employeesByKey: Record<string, Employee[]>;
  inFlight: Record<string, true>;
  errorsByKey: Record<string, string>;
  ensureEmployees: (
    deptId: number,
    showAll: boolean,
    assignmentRulesParams?: EmployeeAssignmentRulesParams | null
  ) => void;
  showAllByTaskId: Record<number, boolean>;
  setShowAllForTask: (taskId: number, val: boolean) => void;
  manualExecutorsByTaskId: Record<number, Employee[]>;
  handleManualExecutorsChange: (taskId: number, next: Employee[]) => void;
  onManualAssign: (task: Task) => void;
};

export const DistributionRowContext =
  createContext<DistributionRowContextValue | null>(null);
